import React from "react";
import "./VisionValues.css";
import { Container, Col, Row } from "react-bootstrap";
function VisionValues() {
  return (
    <>
      <section className="our-vision">
        <Container>
          <Row className="no-gutters">
            <Col md={{ span: 6 }}>
              <div className="ourvision_text">
                <h2>Vision</h2>
                <p>
                  To be a global leader in providing customised and value-based
                  trading and investment solutions with a focus on customer care
                  via efficiency, transparency, and a client-centric approach.
                </p>
              </div>
            </Col>
            <Col md={{ span: 6 }}>
            <div className="corevalue_text">
              <h3>Core Values</h3>
              <ul>
                <li>Ethical business practices</li>
                <li>
                  Expertise gained through skilled human resources and a
                  relentless pursuit of technological advancements
                </li>
                <li>Customer-centric approach</li>
                <li>Customized and tailored solutions</li>
              </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
export default VisionValues;
